const Backbone = require('backbone');
const Mn = require('backbone.marionette');
const AccountRepository = require('jiji/domain/repository/account');
const AccountListView = require('jiji/ui/view/account/list');
const Template = require('jiji/ui/template/content/user/index.hbs');

module.exports = Mn.View.extend({
    template: Template,
    ui: {
        addButton: '.add'
    },
    events: {
        'click @ui.addButton': 'add'
    },
    regions: {
        accounts: '.accounts'
    },

    onRender: function() {
        AccountRepository.getLoginUserAccounts().then(accounts => {
            this.showChildView('accounts', new AccountListView({
                collection: new Backbone.Collection(accounts)
            }));
        });
    },
});



// WEBPACK FOOTER //
// ./jiji/ui/view/content/user/index.js